import { render, staticRenderFns } from "./ProposalStepHeader.vue?vue&type=template&id=c3b887f2&scoped=true&"
import script from "./ProposalStepHeader.vue?vue&type=script&lang=js&"
export * from "./ProposalStepHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProposalStepHeader.vue?vue&type=style&index=0&id=c3b887f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b887f2",
  null
  
)

export default component.exports